module.exports = "/fonts/icomoon.woff?3c855bb1eadba23d0cb5de0f59a7f833";